<template>
    <div class="xiangmu">
<!--        <breadcrumb :routerList="[{to:'/dingd/orderInfo',title:'订单管理'},{title:'发货信息'}]" style="width:100%"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="订单编号" prop="sapCodeLike" style="width: 50%;">
						    <el-input
						            v-model="formInline.sapCodeLike"
						            placeholder="多订单模糊查询请用空格或分号分隔"
						            clearable></el-input>
						</el-form-item>
						<el-form-item label="　　订单创建时间" prop="cdate" style="width: 50%;">
							<el-date-picker
								v-model="formInline.cdatebegin"
								clearable
								type="date"
								value-format="yyyy-MM-dd" >
							</el-date-picker>
							<span class="w-time-to">至</span>
							<el-date-picker
								v-model="formInline.cdateend"
								clearable
								type="date"
								value-format="yyyy-MM-dd" >
							</el-date-picker>
						</el-form-item>
					</div>
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="合单编号" prop="closingTicketCode">
								    <el-input
								            v-model="formInline.closingTicketCode"
								            placeholder="请输入"
								            clearable></el-input>
								</el-form-item>
								<el-form-item label="　　是否有备件" prop="isStockUp">
									<el-select v-model="formInline.isStockUp" :clearable="true"
											   placeholder="请选择">
										<el-option label="是" value="1"></el-option>
										<el-option label="否" value="0"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="　　是否有唛头" prop="marks">
									<el-select v-model="formInline.marks" :clearable="true"
											   placeholder="请选择">
										<el-option label="是" value="1"></el-option>
										<el-option label="否" value="0"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="件数/重量/尺寸" prop="numWeightSize" >
									<el-input
											v-model="formInline.numWeightSize"
											placeholder="请输入"
											clearable></el-input>
								</el-form-item>
							</div>	
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="　　要求送货日期" prop="deliveryTime" style="width: 50%;">
									<el-date-picker
										v-model="formInline.deliveryTimeBegin"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
									</el-date-picker>
									<span class="w-time-to">至</span>
									<el-date-picker
										v-model="formInline.deliveryTimeEnd"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
									</el-date-picker>
								</el-form-item>
							</div>	
						</div>
					</el-collapse-transition>
                    <!-- <div class="h-formBtnOut" style="margin-left: 0.2rem;">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                    </div> -->
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
					</div>
				</div>
            </div>
        </div>

        <div class="h-table h-mrt30">
            <el-table
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    stripe
					border
                    style="width: 100%"
					max-height="450"
            >
                <el-table-column
                        type="selection"
                        width="40"
                        :label="all"
						fixed
                >
                </el-table-column>
				<el-table-column
					   type="index"
					   fixed
					   label="#"
					   width="40">
				</el-table-column>
                <el-table-column
                        prop="sapCode"
						fixed
                        :show-overflow-tooltip="true"
                        label="订单编号"
						width="120">
                </el-table-column>
                <el-table-column
                        prop="closingTicketCode"
                        label="合单编号"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        :show-overflow-tooltip="true"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="partsNum"
                        label="备件件数"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="marks"
                        label="是否有唛头"
                        :show-overflow-tooltip="true">
                     <template slot-scope="scope">
                      <div v-if="scope.row.marks == 1">有</div>
                      <div v-if="scope.row.marks == 0">无</div>
                      <div v-else></div>
                     </template>
                </el-table-column>
                <el-table-column
                        prop="numWeightSize"
                        label="件数/重量/尺寸"
                        :show-overflow-tooltip="true"
                        width="170">
                </el-table-column>
                <el-table-column
                        prop="deliveryTime"
                        label="要求送货日期"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>

                <!--
                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        :show-overflow-tooltip="true"
                        width="240">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.soldToName}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="dnStatus"
                        label="信用查询是否通过"
                        :show-overflow-tooltip="true"
                        width="170">
                    <template scope="scope">
                        {{scope.row.dnStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="note"
                        label="订单备注"
                        :show-overflow-tooltip="true"
                        width="150">
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.note}}
							</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品大类"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品型号"
                        :show-overflow-tooltip="true"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="proType"
                        label="型号属性"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="isCustommed"
                        label="常规或改制"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isCustommed == 0">
                            常规
                        </div>
                        <div v-else>
                            改制
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="extraDes"
                        label="改制描述"
                        :show-overflow-tooltip="true"
                        width="220">
                </el-table-column>
                <el-table-column
                        prop="boxing"
                        label="装箱方式"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="boxNum"
                        label="箱数"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="产品数量"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="availableNum"
                        label="可用库存"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="syNum"
                        label="剩余库存"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="payMethod"
                        label="付款方式"
                        width="220"
                        :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        {{`现金占用：${ scope.row.jinexj } ${ scope.row.currencyCode }`}}
                        <br/>
                        {{`信贷占用：${ scope.row.jinexd } ${ scope.row.currencyCode }`}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="sptgTime"
                        label="审核时间"
                        :show-overflow-tooltip="true"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="soldToAreaName"
                        label="售达方区域/国家"
                        :show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        :show-overflow-tooltip="true"
                        width="200">
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="创建人"
                        :show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                -->

                <el-table-column
                        label="操作"
                        width="100"
                        fixed="right"
                >
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: center;">
							<el-button
							        type="text"
							        size="small"
									style="padding: 0;"
							        class="h-tableLink h-btn"
							        @click="goDetails(scope.row)">
							    查看附件
							</el-button>
						</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="downloadExcel">批量导出
                    </el-button>

                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>

        <!-- 合票附件弹窗 -->
        <el-dialog
                :visible.sync="showClosingTicket"
                v-if="showClosingTicket"
                class="h-dialog2"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>合票附件详情</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">订单号:</h3>
                <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{refid}}</h4>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">唛头格式</h3>
                <brupload
                         style="margin-top: 0.1rem;"
                        @filecallback="fjStatusA"
                        :refid="refid"
                        reftype="FH_MARKS"
                        :uploadflag = "false"
                        :delflag = "false"/>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="boxs == 'LCL'">
                <h3 style="display: inline-block;">拼箱信息表</h3>
                <brupload
                         style="margin-top: 0.1rem;"
                        @filecallback="fjStatusA"
                        :refid="refid"
                        reftype="FH_boxTable"
                        :uploadflag = "false"
                        :delflag = "false"/>
            </div>
            <div class="h-formLine" style="padding:0.2rem;border-bottom: 1px dashed #ccc;" v-if="boxs == 'FCL'">
                <h3 style="display: inline-block;">装箱图</h3>
                <brupload
                         style="margin-top: 0.1rem;"
                        @filecallback="fjStatusA"
                        :refid="refid"
                        reftype="FH_boxMap"
                        :uploadflag = "false"
                        :delflag = "false"/>
            </div>
        </el-dialog>

    </div>
</template>
<script>

    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				ddhB:'',
				refid: null,
				boxs: null,
                // 新手引导页
                status: 1,
                checked: true,
                //内外销区分
                roleType: '2',
                //当前登陆人的权限列表
                rolelist: [],
                instid: null,
                showhistory: null,
                imgflag3: false,
                orderTypeList: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                spanArr: [],
                //表单
                formInline: {
                    orderCategory: '',
                    sapCodeLike: '',

                    marks: '',
                    isStockUp: '',
                    deliveryTimeBegin: '',
                    deliveryTimeEnd: '',
                    closingTicketCode: '',
                    numWeightSize: '',

                    materialCodeLike: '',
                    payMethodLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    oid: '',
                    materialCode: '',
                    payMethod: '',
                    ids: '',
                    orderStatus: '',
                    cuname: '',
                    cdatebegin: '',
                    cdateend: '',
                    soldToAreaName: '',
                    flagWx: '21',

                    closingTicketCode: null,
                    deliveryTime: null,
                    partsNum: null,
                    marks: null,
                    numWeightSize: null,
                },
                all: '全部',
                showClosingTicket: null,
                closingTicketCode: null,
                deliveryTime: null,
                partsNum: null,
                marks: null,
                numWeightSize: null,
                //表格
                multipleSelection: [],
                tableData: [],
                sapCodes: [],
                clickActive: 1,
                rules:{
                    closingTicketCode:[
                        { required: true, message: '请填写合票号', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            //查看附件弹窗
            goDetails(row) {
                this.id = row.id;
                this.refid = row.sapCode;
                this.boxs = row.boxing;
                this.showClosingTicket = true;
            },

            fjStatusA() {
                var saps = _.join(_.map(this.multipleSelection,"sapCode"),",");
                //console.log('saps', saps);
                ss.OrderMainService.updateFjStatusA(saps).then(rd => {
                });
            },
            // 重置按钮
            resetData() {
                this.formInline.sapCodeLike = "";
                this.formInline.isStockUp = "";
                this.formInline.marks = "";
                this.formInline.deliveryTimeBegin = "";
                this.formInline.deliveryTimeEnd = "";
                this.formInline.closingTicketCode = "";
                this.formInline.numWeightSize = "";
                this.formInline.cdatebegin = "";
                this.formInline.cdateend = "";
                this.query();
            },

            //查询该用户及所有子用户所有订单详情

            query() {
                ss.OrderMainService.selectStockPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.tableData.forEach((item, index) => {
                        item.availableNum = item.availableNum || 0;
                        item.syNum = item.availableNum;
                    })
                    console.log('我在这儿呀', this.tableData);
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].sapCode === this.tableData[index - 1].sapCode) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                if (column.label == '经销商' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (column.label == '订单编号' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if ((column.label == '付款方式' || column.label == '操作') &&
                    (row.status == '10' || row.orderCategory == '2')) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //导出Excel
            downloadExcel() {
                this.$msg.confirm("确认导出?", () => {
                    var idlist = [];
                    this.multipleSelection.forEach(element => {
                        idlist.push(element.sapCode);
                    });
                    var q = this.formInline;
                    if (idlist) {
                        q.id = idlist.join(",");
                    } else {
                        q.id ='';
                    }
                    console.log("q", q);
                    updownfile.down("/api/swyl/v1/dingdmain/getOrderExcelC", q, "post", 'params');
                })
            },

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                var str = '';
                this.multipleSelection.forEach(element => {
                    element.syNum = element.availableNum - element.proNumber;
                    str += element.sapCode + ',';
                });
                str = str.substring(0,str.length-1);
                this.ddhB = str;
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },

        },
        created() {
            this.query();
        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step1 {
            top: 0.8rem;
            left: 0rem;
            width: 4.9rem;
            height: 8rem;
        }

        .step2 {
            top: 1.65rem;
            left: 2.8rem;
            width: 10.2rem;
            height: 1.85rem;
        }

        .step3 {
            top: 3.65rem;
            right: 0.8rem;
            width: 5rem;
            height: 1rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.65rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
